import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { useReviewAndRatings } from '@/features/faq/review-ratings/hooks/useReviewAndRatings';
import { ReviewAndRatingsTable } from '@/features/faq/review-ratings/table';
import { Translation } from '@/hoslog-intl';
import { StarIcon } from '@/icons';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum([
    'reviewId',
    'nickName',
    'ratingScale',
    'japaneseRemark',
    'message',
    'storeNameEng',
    'visitingDateTime',
    'createdDate',
  ]),
  desc: z.boolean(),
});

const ratingSearchSchema = z
  .object({
    sort: z
      .preprocess((val) => {
        if (typeof val === 'string') {
          try {
            return JSON.parse(val);
          } catch {
            return undefined;
          }
        }
        return val;
      }, z.array(sortItemSchema))
      .optional(),

    q: z
      .any()
      .optional()
      .transform((val) => (val == null ? undefined : String(val))),
    ratingsFilter: z.number().optional(),
    status: z
      .string()
      .transform((val) => val.split(','))
      .pipe(z.array(z.enum(['ONE STAR', 'TWO STAR', 'THREE STAR', 'FOUR STAR', 'FIVE STAR'])))
      .optional(),
    page: z.coerce.number().positive().catch(0),
    fetch: z.coerce.number().positive().max(100).catch(10),
  })
  .passthrough();

export const Route = createFileRoute('/(app)/faq/review-ratings/')({
  loader: () => {
    return {
      crumb: <CrumbTitle id="faq.reviewRating.crumb" icon={StarIcon} />,
      title: <Translation id="faq.reviewRating.title" />,
    };
  },
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => ratingSearchSchema.parse(search),
});

function RouteComponent() {
  const { reviews, pagination, loading } = useReviewAndRatings();
  return <ReviewAndRatingsTable data={reviews} pagination={pagination} loading={loading} />;
}
